import httpClient from './httpClient'

export default {
  async createComparison(comparisonObject) {
    let ret = await httpClient.post('/comparison', comparisonObject)
    return ret
  },
  async getOneComparison(comparisonId) {
    let ret = await httpClient.get(`/comparison/${comparisonId}`)
    return ret
  },
  async getComparisons() {
    let ret = await httpClient.get('/comparison/')
    return ret
  },
  async updateComparison(comparisonObject, comparisonId) {
    let ret = await httpClient.put(`/comparison/${comparisonId}?type=update`, comparisonObject)
    return ret
  },
  async deleteComparison(comparisonList) {
    let ret = await httpClient.delete('/comparison/', { data: { comparison_ids: comparisonList } })
    return ret
  },
  async startComparison(comparisonId) {
    let ret = await httpClient.put(`/comparison/${comparisonId}?type=start`)
    return ret
  },
  async finishComparison(comparisonId, winnerVideoId) {
    let ret = await httpClient.put(`/comparison/${comparisonId}?type=finish`, { winner_video_id: winnerVideoId })
    return ret
  },
}